






























import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import {
    Form,
    FormItem,
    Input
} from "iview";
Vue.component("Form", Form);
Vue.component("FormItem", FormItem);
Vue.component("Input", Input);
@Component({
    components: {

    }
})
export default class Changepasswd extends Vue {
    @Prop({
        default: 'K12'
    }) type!: string
    private showAlert: boolean = false;
    private hasOld: boolean = true;
    private validatePass = (rule: any, value: any, callback: any): void => {
        if (value === "") {
            callback(new Error("请输入新密码"));
        } else {
            if (value.length < 5) {
                callback(new Error("密码过短"));
            }
            callback();
        }
    };
    private validatePassCheck = (rule: any, value: any, callback: any): void => {
        if (value === "") {
            callback(new Error("请再次输入新密码"));
        } else if (value != (this as any).formCustom.newpasswd) {
            callback(new Error("密码不一致"));
        } else {
            callback();
        }
    };
    private validateoldpasswd = (rule: any, value: any, callback: any): void => {
        if (!value) {
            return callback(new Error("请输入旧密码"));
        } else {
            if (value.length < 5) {
                callback(new Error("密码过短"));
            }
            callback();
        }
    };
    private formCustom: object = {
        oldpasswd: "",
        newpasswd: "",
        checkpasswd: ""
    };
    private ruleCustom: object = {
        oldpasswd: [{
            validator: this.validateoldpasswd,
            trigger: "blur"
        }],
        newpasswd: [{
            validator: this.validatePass,
            trigger: "blur"
        }],
        checkpasswd: [{
            validator: this.validatePassCheck,
            trigger: "blur"
        }]
    };
    private close() {
        (this as any).$refs["formCustom1"].resetFields();
        (this as any).showAlert = false;
    }
   private xgpasswd() {
        (this as any).$refs.formCustom1.validate((valid: boolean) => {
            console.log("valid: ", valid);
            if (valid) {
                (this as any)
                .request("/user/updatePassword.json", {
                        method: "post",
                        data: {
                            oldPassword: (this as any).formCustom.oldpasswd,
                            newPassword: (this as any).formCustom.newpasswd
                        }
                    })
                    .then((res: any) => {
                        console.log("res: ", res);
                        (localStorage as any).clear("userinfo");
                        (this as any).$Cookie.remove("session_dc");
                        this.$store.commit('changeuserAvatar', '');
                        this.$store.commit('changerole', '');
                        (this as any).$alert({
                            msg: res.msg,
                            sureBtnTxt:'重新登录',
                            sureFun: () => {
                                window.location.href = "/k12ts/login.html";
                            }
                        });
                        (this as any).showAlert = false;
                        (this as any).$refs["formCustom1"].resetFields();
                    });
            }
        });
    }
    private sure() {
        (this as any).$refs.formCustom1.validate((valid: boolean) => {
            if (valid) {
                (this as any)
                .request("/user/updateInitPassword.json", {
                        method: "post",
                        data: {
                            newPassword: (this as any).formCustom.newpasswd,
                            confirmNewPassword: (this as any).formCustom
                                .checkpasswd
                        }
                    })
                    .then((res: any) => {
                        (this as any).$alert({
                            msg: res.msg
                        });
                        (this as any).showAlert = false;
                        (this as any).$refs["formCustom1"].resetFields();

                    });
            }
        });
    }
    private mounted() {}
}
